import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import './light-datetime-lincoln.scss';
import Calendar from '../calendar';
import { TimeslotPicker } from '../timeslot-picker';
import {
    AvailableDates,
    DealerCalendarDetails,
    TimeRange,
} from '../../../../../models/osb-model/dealer-calendar-details';
import OsbUtilService from '../../../../../services/osb-service/osb-util-service/osb-util-service';
import {
    DATE_TIME_STEP,
    STEP_PROGRESS_BAR_KEYS,
    LIGHT_JOURNEY_ANALYTICS,
    OSB_CLIENT_STORAGE_KEYS,
    SERVICE_FLOW,
    SERVICE_DELIVERY_TYPE,
} from '../../osb-constant';
import {
    useCalendarStep,
    useHttp,
    useLightDeliveryOptionServiceStep,
    useOSBStep,
    usePersonalDetailStep,
    useServiceStep,
    useStepProgressBar,
    useVehicleStep,
    useViewport,
    useDealerStep,
    useServiceLocationStep,
    useRetrieveBookingStep,
    usePageRefresh,
} from '../../../../../hooks/owners-osb';
import { LightBookingSummary } from '../../light-booking-summary/light-booking-summary';
import BookingSummaryAccordion from '../../light-booking-summary/booking-summary-accordion/booking-summary-accordion';
import { OSBSecondaryButton } from '../../common/osb-secondary-button/osb-secondary-button';
import {
    triggerBookServiceGlobalCTAOnClickAnalytics,
    triggerDateTimeLoadAnalytics,
    triggerDateTimeLoadErrorAnalytics,
    triggerRetrieveAmendDateAndTImeLoadAnalytics,
    triggerRetrieveDateTimeAmendErrorAnalytics,
} from '../../analytics/osb-analytics';
import { useAnalytics } from '../../../../../hooks/use-analytics';
import {
    OsbPathBookingRetrieveSummaryStep,
    OsbPathBookingReviewStep,
    OsbPathCalenderStep,
    OsbPathDeliveryStep,
    OsbPathPersonalDetailsStep,
    OsbPathServiceLocationStep,
    OsbPathServicesStep,
} from '../../osb-controller';
import {
    setRouteToPersist,
    buildNavigationUrl,
    getLightVehicleData,
    ErrorResponse,
    isConvenienceOptionTypePresent,
    formatMobileNumber,
    getGoMainHeaderHeight,
    extractTimeString,
    getFirstTimeSlotOrDefault,
} from '../../osb-utils';
import Popup from 'reactjs-popup';
import { useHistory } from 'react-router-dom';
import { OsbLoader } from '../../../../common/osb-loader/osb-loader';
import { LightPickupCalendar } from './light-pickup-service-calendar';
import ServiceHandler from '../../../../../services/service-handler';
import { OSBPayload } from '../../../../../services/shortcode-service/shortcode-service';
import serverSideService from '../../../../../services/server-side-service/server-side-service';
import { useCampaignStatesStep } from '../../../../../hooks/owners-osb/use-campaign-states-step';
import { useAllOSBState } from '../../../../../hooks/owners-osb/use-all-osb-state';
import useDealerCalendarAvailability from '../../../../../hooks/owners-osb/use-dealer-calendar-availability';
import { FMButton } from '@own/fds-react';
import { useOSBContentFragment } from '../../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
const dateFns = require('date-fns');

const appConfig = OsbUtilService.getAppConfiguration();
const localeAsString = appConfig.languageRegionCode;

const getSelectedDate = (isMobileView: boolean, osbCalendarStep: any) => {
    if (isMobileView) {
        return osbCalendarStep.selectedDate.length > 0
            ? osbCalendarStep.selectedDate
            : '';
    }
    return osbCalendarStep.selectedDate.length > 0
        ? osbCalendarStep.selectedDate
        : '';
};

const getSelectedTime = (osbCalendarStep: any) => {
    return osbCalendarStep.selectedTime.length > 0
        ? osbCalendarStep.selectedTime
        : '';
};

const getSelectedTimeRange = (osbCalendarStep: any) => {
    return osbCalendarStep.selectedTimeRange.length > 0
        ? osbCalendarStep.selectedTimeRange
        : '';
};

const getFilterTime = (results: DealerCalendarDetails, selectDate: string) => {
    return results?.availableDates?.find(entry => entry.date === selectDate);
};

const getFirstAvailableDate = (results: DealerCalendarDetails) => {
    return results.availableDates[0];
};

const getAvailableTimeSlot = (filterTime: any) => {
    return filterTime?.availableTimeSlots?.[0]
        ? extractTimeString(filterTime.availableTimeSlots[0])
        : '';
};

const setDefaultDateTimePayload = (
    setOSBCalendarStepPayload: any,
    selectDate: string,
    selectTime: string,
    selectTimeRange: string
) => {
    setOSBCalendarStepPayload({
        selectedDate: selectDate,
        selectedTime: selectTime,
        selectedTimeRange: selectTimeRange,
    });
};

const setDefaultDateTimeState = (
    setDefaultTime: any,
    setDefaultTimeRange: any,
    selectTime: string,
    selectTimeRange: string
) => {
    setDefaultTime(selectTime);
    setDefaultTimeRange(selectTimeRange);
};

const setDefaultDateTimeWithFilter = (
    setOSBCalendarStepPayload: any,
    setDefaultTime: any,
    setDefaultTimeRange: any,
    selectDate: string,
    filterTime: any,
    filterTimeRange: string
) => {
    setOSBCalendarStepPayload({
        selectedDate: selectDate,
        selectedTime: getAvailableTimeSlot(filterTime),
        selectedTimeRange: filterTimeRange,
    });
    setDefaultTime(getAvailableTimeSlot(filterTime));
    setDefaultTimeRange(filterTimeRange);
};

const setDefaultDateTimeWithFirstAvailable = (
    setOSBCalendarStepPayload: any,
    setDefaultDate: any,
    setDefaultTime: any,
    setDefaultTimeRange: any,
    results: DealerCalendarDetails,
    trimDefaultTimeRange: any
) => {
    const firstAvailable = getFirstAvailableDate(results);
    setOSBCalendarStepPayload({
        selectedDate: firstAvailable?.date,
        selectedTime: getAvailableTimeSlot(firstAvailable),
        selectedTimeRange: trimDefaultTimeRange(
            firstAvailable?.availableTimeRanges
        ),
    });
    setDefaultDate(firstAvailable?.date);
    setDefaultTime(getAvailableTimeSlot(firstAvailable));
    setDefaultTimeRange(
        trimDefaultTimeRange(firstAvailable?.availableTimeRanges)
    );
};

export const setAvailableSlotsAndRanges = (
    setAvailableTimeSlots: any,
    setAvailableTimeRanges: any,
    osbCalendarStep: any,
    results: DealerCalendarDetails,
    trimSecondsFromTimeslots: any,
    trimSecondsFromTimesRange: any
) => {
    if (results.availableDates.length > 0) {
        if (osbCalendarStep.selectedDate.length > 0) {
            const filtered = results.availableDates.filter(
                entry => entry.date === osbCalendarStep.selectedDate
            )[0];
            setAvailableTimeSlots(
                trimSecondsFromTimeslots(filtered?.availableTimeSlots || [])
            );
            setAvailableTimeRanges(
                trimSecondsFromTimesRange(filtered?.availableTimeRanges || [])
            );
        } else {
            const first = results.availableDates[0];
            setAvailableTimeSlots(
                trimSecondsFromTimeslots(first?.availableTimeSlots || [])
            );
            setAvailableTimeRanges(
                trimSecondsFromTimesRange(first?.availableTimeRanges || [])
            );
        }
    }
};

interface Props {
    osbAlertMessagePopup: (alertMessage: string, alertSuccess: boolean) => void;
}
export const LightDateTime = (props: Props) => {
    const dateTimeContent = useOSBContentFragment(
        'common/owners-osb',
        'calendar-step'
    );
    const [showPickupServiceCalendar, setShowPickupServiceCalendar] = useState(
        false
    );
    const [errorMsgService, setErrorMsgService] = useState('');
    const { osbRetrieveBookingStep } = useRetrieveBookingStep();
    const {
        osbStepProgressBar,
        updateProgressBarStatus,
    } = useStepProgressBar();
    const { setOSBCampaignStates } = useCampaignStatesStep();
    const { osbCalendarStep, setOSBCalendarStepPayload } = useCalendarStep();
    const [
        disablePickupCalendarContinueButton,
        setDisablePickupCalendarContinueButton,
    ] = useState(
        !osbCalendarStep.selectedPickupDate ||
            !osbCalendarStep.selectedPickupTime
    );
    const { httpState, dispatch } = useHttp();
    const { osbDealerStep } = useDealerStep();
    const { osbVehicleStep } = useVehicleStep();
    const { osbServiceStep } = useServiceStep();
    const { osbPersonalDetail } = usePersonalDetailStep();
    const { osbLightDeliveryServiceStep } = useLightDeliveryOptionServiceStep();
    const [fireEvents] = useAnalytics();
    const history = useHistory();
    const { osbStep, invalidateAuthentication } = useOSBStep();
    const { isMobileView } = useViewport();
    const { fetchAvailability } = useDealerCalendarAvailability();
    const [
        availableDatesWithTimeslots,
        setAvailableDatesWithTimeslots,
    ] = useState<AvailableDates[]>([]);
    const [isCalendarVisible, setIsCalendarVisible] = useState<boolean>(false);
    const [calendarDateErrorMsg, setCalendarDateErrorMsg] = useState<string>(
        ''
    );
    const [availableTimeSlots, setAvailableTimeSlots] = useState<string[]>([]);
    const [availableTimeRanges, setAvailableTimeRanges] = useState<string[]>(
        []
    );
    const [calendarStartDate, setCalendarStartDate] = useState<string>('');
    const [calendarEndDate, setCalendarEndDate] = useState<string>('');
    const [callDealerPrefix, setCallDealerPrefix] = useState<string>('');
    const [callDealerPostfix, setCallDealerPostfix] = useState<string>('');
    const [callDealerAnchorText, setCallDealerAnchorText] = useState<string>(
        ''
    );
    const [open, setOpen] = useState(false);
    const [defaultTime, setDefaultTime] = useState<string>(
        osbCalendarStep.selectedTime || ''
    );
    const [defaultTimeRange, setDefaultTimeRange] = useState<string>(
        osbCalendarStep.selectedTimeRange || ''
    );
    const [defaultDate, setDefaultDate] = useState<string>(
        osbCalendarStep.selectedDate || ''
    );
    const [isPickupDeliverySelected] = useState(
        isConvenienceOptionTypePresent(
            SERVICE_FLOW.PICKUP_AND_DELIVERY_CONVENIENCE_OPTION_TYPE,
            osbLightDeliveryServiceStep.selectedServices
        ) || false
    );
    const isRetrieveStep = osbStep.isRetrieveFlow;
    const { osbServiceLocationDetail } = useServiceLocationStep();
    let sameDayPickUp =
        osbCalendarStep.dealerCalendarInfo.availableDates?.filter(
            (entry: any) => entry.date === osbCalendarStep.selectedDate
        )[0]?.sameDayPickUp ?? '';
    usePageRefresh();

    const closeModal = () => {
        setOpen(false);
    };

    const loadVoucherAlertMessage = (message: string, success: boolean) => {
        props.osbAlertMessagePopup(message, success);
    };

    const bookable = useAllOSBState();

    const goToPersonalDetailsStep = async () => {
        triggerBookServiceGlobalCTAOnClickAnalytics(
            LIGHT_JOURNEY_ANALYTICS.CONTINUE_BTN_CTA_NAME,
            fireEvents,
            osbVehicleStep
        );
        if (
            isPickupDeliverySelected &&
            !showPickupServiceCalendar &&
            osbStep.enablePickupNDeliveryLocationDateAndTime
        ) {
            // pickup and delivery calendar work only in new calendar design
            setShowPickupServiceCalendar(true);
        } else {
            invalidateAuthentication();
            setOSBCalendarStepPayload({
                selectedTime: defaultTime,
                selectedDate: defaultDate,
                selectedTimeRange: defaultTimeRange,
            });
            if (!defaultDate && isMobileView) {
                setCalendarDateErrorMsg(
                    dateTimeContent?.[
                        DATE_TIME_STEP.PLEASE_SELECT_TEXT
                    ]?.toString() ?? ''
                );

                setIsCalendarVisible(false);
                return;
            }

            updateProgressBarStatus(STEP_PROGRESS_BAR_KEYS.DATETIME, true);
            if (isRetrieveStep) {
                await fetchAvailability();
                history.push(
                    buildNavigationUrl(
                        OsbPathBookingRetrieveSummaryStep(),
                        osbStep.UrlQueryParams
                    )
                );
            } else if (
                osbPersonalDetail.firstName &&
                osbPersonalDetail.lastName &&
                osbPersonalDetail.contactNumber &&
                osbPersonalDetail.email
            ) {
                setRouteToPersist(
                    OSB_CLIENT_STORAGE_KEYS.OSB_PERSISTED_ROUTE_KEY,
                    OsbPathBookingReviewStep(),
                    osbStep.localStorageExpiry
                );

                history.push(
                    buildNavigationUrl(
                        OsbPathBookingReviewStep(),
                        osbStep.UrlQueryParams
                    )
                );
            } else {
                history.push(
                    buildNavigationUrl(
                        OsbPathPersonalDetailsStep(),
                        osbStep.UrlQueryParams
                    )
                );
            }
        }
    };

    function trimSecondsFromTimeslots(selectedTimeslot: string[]) {
        return selectedTimeslot.map(str => extractTimeString(str));
    }
    const trimSecondsFromTimesRange = (selectedTimesRange: TimeRange[]) => {
        const timeRanges: string[] = [];
        for (const range of selectedTimesRange) {
            timeRanges.push(
                extractTimeString(range.start) +
                    ' - ' +
                    extractTimeString(range.end)
            );
        }
        return timeRanges;
    };
    const trimDefaultTimeRange = (range: any) => {
        return getFirstTimeSlotOrDefault(range, '');
    };
    const goToDeliveryServicesStep = () => {
        triggerBookServiceGlobalCTAOnClickAnalytics(
            LIGHT_JOURNEY_ANALYTICS.BACK_BTN_CTA_NAME,
            fireEvents,
            osbVehicleStep
        );
        invalidateAuthentication();
        updateProgressBarStatus(STEP_PROGRESS_BAR_KEYS.DATETIME, false);

        if (isRetrieveStep) {
            history.push(
                buildNavigationUrl(
                    OsbPathBookingRetrieveSummaryStep(),
                    osbStep.UrlQueryParams
                )
            );
            return;
        }
        if (osbServiceStep.isMobileServiceSelected) {
            history.push(
                buildNavigationUrl(
                    OsbPathServiceLocationStep(),
                    osbStep.UrlQueryParams
                )
            );
            return;
        }
        if (!osbDealerStep.isDealerHasDeliveryServices) {
            history.push(
                buildNavigationUrl(
                    OsbPathServicesStep(),
                    osbStep.UrlQueryParams
                )
            );
            return;
        }
        history.push(
            buildNavigationUrl(OsbPathDeliveryStep(), osbStep.UrlQueryParams)
        );
    };
    const fetchSelectedTime = (selectTime: string) => {
        setDefaultTime(selectTime);
        setOSBCalendarStepPayload({ selectedTime: selectTime });
        setOSBCalendarStepPayload({
            selectedPickupDate: '',
            selectedPickupTime: '',
        });
        setDisablePickupCalendarContinueButton(true);
    };

    const fetchSelectedTimeRange = (selectTimeRange: string) => {
        setDefaultTimeRange(selectTimeRange);
        setOSBCalendarStepPayload({ selectedTimeRange: selectTimeRange });
    };

    const fetchSelectedDate = (selectDate: string) => {
        setDefaultDate(selectDate);
        setOSBCalendarStepPayload({ selectedDate: selectDate });
        setIsCalendarVisible(false);
        setCalendarDateErrorMsg('');
        setOSBCalendarStepPayload({
            selectedPickupDate: '',
            selectedPickupTime: '',
        });
        setDisablePickupCalendarContinueButton(true);
    };
    const setServiceAppointmentScreen = () => {
        setShowPickupServiceCalendar(false);
    };

    const fetchSelectedTimeslots = (selectedTimeslot: string[]) => {
        setDefaultTime(
            selectedTimeslot.length > 0
                ? extractTimeString(selectedTimeslot[0])
                : ''
        );
        setOSBCalendarStepPayload({
            selectedTime:
                selectedTimeslot.length > 0
                    ? extractTimeString(selectedTimeslot[0])
                    : '',
        });
        setAvailableTimeSlots(trimSecondsFromTimeslots(selectedTimeslot));
        setOSBCalendarStepPayload({
            selectedPickupDate: '',
            selectedPickupTime: '',
        });
        setDisablePickupCalendarContinueButton(true);
    };
    const fetchSelectedTimeRanges = (selectedTimeRange: TimeRange[]) => {
        setDefaultTimeRange(getFirstTimeSlotOrDefault(selectedTimeRange, ''));
        setOSBCalendarStepPayload({
            selectedTimeRange: getFirstTimeSlotOrDefault(selectedTimeRange, ''),
        });
        setAvailableTimeRanges(trimSecondsFromTimesRange(selectedTimeRange));
    };
    const isSelectedDateAvailable = (
        selectDate: string,
        availableDates: AvailableDates[]
    ) => {
        return (
            availableDates.filter(entry => entry.date === selectDate).length > 0
        );
    };

    const isSelectedTimeAvailable = (
        selectTime: string,
        selectedDate: string,
        selectTimeRange: string,
        availableDates: AvailableDates[]
    ) => {
        const availableDts = availableDates?.filter(
            entry => entry.date === selectedDate
        );
        const timeRanges = trimSecondsFromTimesRange(
            availableDts?.[0]?.availableTimeRanges?.[0]
                ? availableDts?.[0]?.availableTimeRanges
                : []
        );
        const filterSelectedRange = timeRanges.filter(
            range => range === selectTimeRange
        );

        if (
            availableDts?.[0]?.availableTimeSlots?.includes(
                `${selectTime}:00`
            ) ||
            (filterSelectedRange && filterSelectedRange.length > 0)
        ) {
            return true;
        }
        return false;
    };
    const setDefaultStartAndEndDate = () => {
        const newDate = dateFns.format(new Date(), 'yyyy-MM-dd').toString();
        const newMonth = new Date().getMonth() + 3;
        setCalendarStartDate(newDate);
        setCalendarEndDate(
            new Date().getFullYear() +
                '-' +
                newMonth +
                '-' +
                new Date().getDay()
        );
    };

    const getSameDayPickUp = (selectDate: string, results: any) => {
        sameDayPickUp = results?.find((entry: any) => entry.date === selectDate)
            ?.sameDayPickUp;
    };

    const initCalendar = (results: DealerCalendarDetails) => {
        setAvailableDatesWithTimeslots(results ? results.availableDates : []);
        if (results.availableDates?.length === 0) {
            setDefaultStartAndEndDate();
            setAvailableSlotsAndRanges(
                setAvailableTimeSlots,
                setAvailableTimeRanges,
                osbCalendarStep,
                results,
                trimSecondsFromTimeslots,
                trimSecondsFromTimesRange
            );
            dispatch({ type: 'RESPONSE' });
            return;
        }

        setCalendarStartDate(results ? results.calendarStart : '');
        setCalendarEndDate(results ? results.calendarEnd : '');

        const selectDate = getSelectedDate(isMobileView, osbCalendarStep);
        const selectTime = getSelectedTime(osbCalendarStep);
        const selectTimeRange = getSelectedTimeRange(osbCalendarStep);

        if (isSelectedDateAvailable(selectDate, results.availableDates)) {
            setDefaultDate(selectDate);
            if (
                isSelectedTimeAvailable(
                    selectTime,
                    selectDate,
                    selectTimeRange,
                    results.availableDates
                )
            ) {
                setDefaultDateTimePayload(
                    setOSBCalendarStepPayload,
                    selectDate,
                    selectTime,
                    selectTimeRange
                );
                setDefaultDateTimeState(
                    setDefaultTime,
                    setDefaultTimeRange,
                    selectTime,
                    selectTimeRange
                );
            } else {
                const filterTime = getFilterTime(results, selectDate);
                const filterTimeRange = trimDefaultTimeRange(
                    results.availableDates[0]?.availableTimeRanges
                );
                setDefaultDateTimeWithFilter(
                    setOSBCalendarStepPayload,
                    setDefaultTime,
                    setDefaultTimeRange,
                    selectDate,
                    filterTime,
                    filterTimeRange
                );
            }
            getSameDayPickUp(selectDate, results.availableDates);
        } else {
            setFirstAvailableDateAndTime(results);
        }
        setAvailableSlotsAndRanges(
            setAvailableTimeSlots,
            setAvailableTimeRanges,
            osbCalendarStep,
            results,
            trimSecondsFromTimeslots,
            trimSecondsFromTimesRange
        );
        dispatch({ type: 'RESPONSE' });
    };

    function setFirstAvailableDateAndTime(results: DealerCalendarDetails) {
        osbCalendarStep.selectedDate = results?.availableDates?.[0]?.date || '';
        osbCalendarStep.selectedTime = results?.availableDates?.[0]
            ?.availableTimeSlots?.[0]
            ? extractTimeString(results.availableDates[0].availableTimeSlots[0])
            : '';
        setDefaultDateTimeWithFirstAvailable(
            setOSBCalendarStepPayload,
            setDefaultDate,
            setDefaultTime,
            setDefaultTimeRange,
            results,
            trimDefaultTimeRange
        );
        sameDayPickUp = results?.availableDates?.[0]?.sameDayPickUp ?? '';
    }
    const processCallDealerText = (callDealerText: string | undefined) => {
        if (callDealerText) {
            let cdtext = callDealerText.replace('<p>', '');
            cdtext = cdtext.replace('</p>', '');
            const callDealerArr = cdtext.split('&lt;CTD&gt;');
            if (typeof callDealerArr[1] !== 'undefined') {
                const callDealerArr1 = callDealerArr[1].split('&lt;/CTD&gt;');
                setCallDealerPrefix(callDealerArr[0]);
                setCallDealerAnchorText(callDealerArr1[0]);
                if (typeof callDealerArr1[1] !== 'undefined') {
                    setCallDealerPostfix(callDealerArr1[1]);
                }
            } else {
                setCallDealerPrefix(callDealerText);
            }
        } else {
            setCallDealerPrefix(callDealerText ?? '');
        }
    };
    const getFormatedDate = (dateFormatAuthored: string) => {
        return osbCalendarStep.selectedDate
            ? OsbUtilService.constructDisplayDate(
                  osbCalendarStep.selectedDate,
                  dateFormatAuthored
              )
            : '';
    };

    const getCalendarComponent = (): JSX.Element => {
        if (isMobileView && !isCalendarVisible) {
            return <></>;
        }
        return (
            <Calendar
                calendarStart={calendarStartDate}
                calendarEnd={calendarEndDate}
                setSelectedDate={fetchSelectedDate}
                setTimeslots={fetchSelectedTimeslots}
                message={
                    dateTimeContent?.[DATE_TIME_STEP.SELECT_DATE]?.toString() ??
                    ''
                }
                availableDates={availableDatesWithTimeslots}
                initSelectDate={osbCalendarStep.selectedDate}
                localeAsString={localeAsString}
                setTimeRanges={fetchSelectedTimeRanges}
                isMobileServiceSelected={osbServiceStep.isMobileServiceSelected}
            />
        );
    };
    const getTimePickerComponent = (): JSX.Element => {
        return (
            <TimeslotPicker
                data={availableTimeSlots}
                setSelectedTime={fetchSelectedTime}
                setSelectedTimeRange={fetchSelectedTimeRange}
                selectedDate={defaultDate}
                message={
                    dateTimeContent?.[
                        DATE_TIME_STEP.AVAILABLE_TIMES
                    ]?.toString() ?? ''
                }
                initSelectTime={defaultTime}
                initSelectTimeRange={defaultTimeRange}
                isMobileView={isMobileView}
                selectTimeLabel={
                    dateTimeContent?.[
                        DATE_TIME_STEP.SELECT_TIME_SLOT_DROPDOWN_LABEL
                    ]?.toString() ?? ''
                }
                timeRanges={availableTimeRanges}
                hasMobileService={osbDealerStep.hasMobileService}
                isMobileServiceSelected={osbServiceStep.isMobileServiceSelected}
            />
        );
    };

    const showCalendar = () => {
        setIsCalendarVisible(true);
        setCalendarDateErrorMsg('');
    };

    const triggerCallDealerCtaAnalytics = () => {
        const osbCallDealerInfo: OSBPayload = {
            dealerID: osbDealerStep.selectedDealerId,
        };
        fireEvents(
            LIGHT_JOURNEY_ANALYTICS.EVENT_BOOK_SERVICE_CALL_DEALER_CTA,
            LIGHT_JOURNEY_ANALYTICS.TARGET_TRIGGER_VIEW,
            {
                osbPayload: osbCallDealerInfo,
            },
            false
        );
    };

    const getSelectedServicePayLoad = () => {
        const serviceStepServiceIds = OsbUtilService.getServiceIDs(
            osbServiceStep.selectedServices
        );

        const deliveryStepServiceIds = OsbUtilService.getServiceIDs(
            osbLightDeliveryServiceStep.selectedServices
        );

        return [...serviceStepServiceIds, ...deliveryStepServiceIds];
    };

    const fetchCalendarResponse = async () => {
        const vehicleData = getLightVehicleData(osbVehicleStep);
        const selectedDealerProfile = osbDealerStep.selectedDealerProfile;
        const bookingDetails = osbRetrieveBookingStep.retrieveBookingDetails;
        let selectedDealerCode = '';
        if (isRetrieveStep && !OsbUtilService.isEmptyObject(bookingDetails)) {
            selectedDealerCode = bookingDetails.bookings[0].dealer.dealerCode;
        }
        if (selectedDealerCode === '') {
            selectedDealerCode =
                selectedDealerProfile.dealerCode ||
                osbDealerStep.selectedDealerId ||
                '';
        }

        await ServiceHandler.OsbDealerCalendarAvailability.getCalendarInfo({
            dealerCode: selectedDealerCode,
            serviceDeliveryType:
                osbDealerStep.hasMobileService &&
                osbServiceStep.isMobileServiceSelected
                    ? SERVICE_DELIVERY_TYPE.MOBILESERVICE
                    : '',
            selectedServices: getSelectedServicePayLoad(),
            vehicleData: vehicleData,
            requestSourceType: osbStep.source,
            bookable: bookable,
            DSLAPIVersion: osbStep.DSLAPIVersion,
        })
            .then(results => {
                // resetting selectedDate and selectedTime to blank,
                // to initilize calendar and timeslot component
                setOSBCalendarStepPayload({
                    selectedDate: '',
                    selectedTime: '',
                    selectedTimeRange: '',
                });
                setOSBCalendarStepPayload({
                    dealerCalendarInfo: results.value,
                });
                if (results.value?.availableDates?.length === 0) {
                    setDefaultStartAndEndDate();
                    dispatch({ type: 'RESPONSE' });
                } else {
                    initCalendar(results.value);
                }
                if (Array.isArray(results.value?.campaignStates)) {
                    setOSBCampaignStates({
                        campaignStates: [...results.value.campaignStates],
                    });
                }
                setErrorMsgService('');
            })
            .catch((error: ErrorResponse) => {
                setErrorMsgService(osbStep.internalErrorMessage);
                if (error?.statusCode && error?.statusCode === 400) {
                    setDefaultStartAndEndDate();
                    osbCalendarStep.selectedDate = '';
                    osbCalendarStep.selectedTime = '';
                    setOSBCalendarStepPayload({
                        selectedDate: '',
                        selectedTime: '',
                        selectedTimeRange: '',
                    });
                    dispatch({ type: 'RESPONSE' });
                }

                if (!isRetrieveStep) {
                    triggerDateTimeLoadErrorAnalytics(
                        osbServiceStep.totalPriceForAnalytics ?? '0.00',
                        [
                            ...osbServiceStep.selectedServices,
                            ...osbLightDeliveryServiceStep.selectedServices,
                        ],
                        osbServiceStep.voucherCode,
                        osbVehicleStep,
                        osbStep,
                        fireEvents,
                        LIGHT_JOURNEY_ANALYTICS.NO_AMEND_FLOW_CONTENT
                    );
                } else {
                    triggerRetrieveDateTimeAmendErrorAnalytics(
                        osbVehicleStep,
                        osbStep,
                        fireEvents,
                        LIGHT_JOURNEY_ANALYTICS.AMEND_FLOW_CONTENT
                    );
                }
            });
    };
    const pickupDateOrTimeslotChange = () => {
        setDisablePickupCalendarContinueButton(
            osbCalendarStep.selectedPickupDate?.length <= 0 ||
                osbCalendarStep.selectedPickupTime?.length <= 0
        );
    };
    const pickupDateChange = (pickupDate: string) => {
        setOSBCalendarStepPayload({ selectedPickupDate: pickupDate });
        pickupDateOrTimeslotChange();
    };
    const pickupTimeslotChange = (pickupTimeslot: string) => {
        setOSBCalendarStepPayload({ selectedPickupTime: pickupTimeslot });
        pickupDateOrTimeslotChange();
    };
    useEffect(() => {
        processCallDealerText(dateTimeContent?.text?.toString());
    }, [dateTimeContent]);
    useEffect(() => {
        dispatch({ type: 'REQUEST' });
        (async () => {
            await fetchCalendarResponse();
            dispatch({ type: 'RESPONSE' });
        })();
        if (serverSideService.isClientSide()) {
            window.scrollTo({
                top: getGoMainHeaderHeight() - 2,
                behavior: 'smooth',
            });
        }
    }, [isMobileView]);

    useEffect(() => {
        updateProgressBarStatus(STEP_PROGRESS_BAR_KEYS.DATETIME, false, true);
        const stepDetails = osbStepProgressBar.progressBarDetails.find(
            step =>
                step.key === STEP_PROGRESS_BAR_KEYS.DATETIME && step.isEditable
        );

        if (stepDetails || osbStep.isRetrieveFlow) {
            setRouteToPersist(
                OSB_CLIENT_STORAGE_KEYS.OSB_PERSISTED_ROUTE_KEY,
                OsbPathCalenderStep(),
                osbStep.localStorageExpiry
            );
            if (!isRetrieveStep) {
                triggerDateTimeLoadAnalytics(
                    osbServiceStep.totalPriceForAnalytics ?? '0.00',
                    [
                        ...osbServiceStep.selectedServices,
                        ...osbLightDeliveryServiceStep.selectedServices,
                        ...osbServiceLocationDetail.selectedOtherOptions,
                    ],
                    osbServiceStep.voucherCode,
                    osbVehicleStep,
                    osbStep,
                    fireEvents,
                    LIGHT_JOURNEY_ANALYTICS.NO_AMEND_FLOW_CONTENT
                );
            }

            if (isRetrieveStep) {
                triggerRetrieveAmendDateAndTImeLoadAnalytics(
                    osbVehicleStep,
                    osbStep,
                    fireEvents,
                    LIGHT_JOURNEY_ANALYTICS.AMEND_FLOW_CONTENT
                );
            }
        }
    }, []);
    // --- Helper render functions to reduce complexity ---

    function renderBackButton() {
        if ((osbStep.isWebViewJourney || !isMobileView) && !isRetrieveStep) {
            return (
                <OSBSecondaryButton
                    dataTestId="BackLinkToDeliveryOptionPage"
                    type="svg"
                    direction="left"
                    text={
                        dateTimeContent?.[
                            DATE_TIME_STEP.BACK_ON_CALENDAR
                        ]?.toString() ?? ''
                    }
                    onClickHandler={goToDeliveryServicesStep}
                />
            );
        }
        return null;
    }

    function renderDateTimeTitle() {
        if (!httpState.isLoading) {
            return (
                <div className="datetime-title">
                    <div
                        dangerouslySetInnerHTML={{
                            __html:
                                dateTimeContent?.[
                                    isMobileView
                                        ? DATE_TIME_STEP.MOBILE_TITLE
                                        : DATE_TIME_STEP.TITLE
                                ]?.toString() ?? '',
                        }}
                    />
                </div>
            );
        }
        return <div></div>;
    }

    function renderCalendarComponentPanel() {
        return (
            <div className="osb-calendar-container-panel">
                <div className="calendar-component">
                    {!isMobileView && (
                        <>
                            <div className="cal-main-head">
                                {dateTimeContent?.[
                                    DATE_TIME_STEP.SELECT_DATE
                                ] ?? ''}
                            </div>
                            <div className="selected-date">
                                {
                                    dateTimeContent?.[
                                        DATE_TIME_STEP.SELECTED_DATE_LABEL
                                    ]
                                }
                                :{' '}
                                {getFormatedDate(
                                    dateTimeContent?.[
                                        DATE_TIME_STEP.DATE_FORMAT_CALENDAR
                                    ]?.toString() ?? ''
                                )}
                            </div>
                        </>
                    )}

                    {isMobileView && (
                        <>
                            <label className="input-label">
                                <div>
                                    {dateTimeContent?.[
                                        DATE_TIME_STEP.PLACEHOLDER_LABEL
                                    ] ?? ''}
                                </div>
                            </label>
                            <input
                                id="calendarDate"
                                data-testid="calendarDateTestId"
                                type="text"
                                className={`input-field${
                                    calendarDateErrorMsg ? '-error' : ''
                                } `}
                                placeholder={
                                    dateTimeContent?.[
                                        DATE_TIME_STEP.PLACEHOLDER_LABEL
                                    ]?.toString() ?? ''
                                }
                                aria-label="calendarDate"
                                aria-labelledby="calendarDate"
                                name="calendarDate"
                                value={getFormatedDate(
                                    dateTimeContent?.[
                                        DATE_TIME_STEP.DATE_FORMAT_CALENDAR
                                    ]?.toString() ?? ''
                                )}
                                onChange={showCalendar}
                                onFocus={showCalendar}
                            />
                        </>
                    )}
                    {calendarDateErrorMsg && (
                        <div className="osb-error-message">
                            {calendarDateErrorMsg}
                        </div>
                    )}
                </div>
                {!isMobileView && (
                    <div className="timeslot-component">
                        <div className="main-head">
                            {dateTimeContent?.[
                                DATE_TIME_STEP.AVAILABLE_TIMES
                            ] ?? ''}
                        </div>
                        <div className="input-label">
                            {dateTimeContent?.[
                                DATE_TIME_STEP.SELECT_TIME_SLOT_DROPDOWN_LABEL
                            ] ?? ''}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    function renderCalSlotSection() {
        return (
            <div className="cal-slot-section">
                <div>{getCalendarComponent()}</div>
                <div className="timeslot-component">
                    {getTimePickerComponent()}
                </div>
            </div>
        );
    }

    function renderContinueButton() {
        return (
            <div className="button-container">
                <div className="continue-button">
                    <FMButton
                        type="primary"
                        label={
                            dateTimeContent?.[
                                DATE_TIME_STEP.CONTINUE_ON_CALENDAR
                            ]?.toString() ?? ''
                        }
                        aria-label={
                            dateTimeContent?.[
                                DATE_TIME_STEP.CONTINUE_ON_CALENDAR
                            ]?.toString() ?? 'Continue'
                        }
                        onClick={goToPersonalDetailsStep}
                    />
                </div>
            </div>
        );
    }

    function renderFooterTextDesktop() {
        if (!isMobileView) {
            return (
                <div
                    className="footer-text"
                    data-testid="same-day-pickup-container"
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html:
                                dateTimeContent?.[DATE_TIME_STEP.DROP_OFF_TITLE]
                                    ?.toString()
                                    .replace(
                                        '####',
                                        extractTimeString(sameDayPickUp)
                                    ) ?? '',
                        }}
                    />
                    {osbDealerStep.selectedDealerProfile.primaryPhone
                        ? callDealerPrefix
                        : ''}
                    {osbDealerStep.selectedDealerProfile.primaryPhone ? (
                        <Popup
                            trigger={
                                <span className="call-dealer-link">
                                    {callDealerAnchorText}
                                </span>
                            }
                            onOpen={triggerCallDealerCtaAnalytics}
                            open={open}
                            className="dealer-call-cta-popup"
                            position="right center"
                            closeOnDocumentClick={true}
                            modal={false}
                            onClose={closeModal}
                        >
                            {osbDealerStep.selectedDealerProfile.primaryPhone}
                        </Popup>
                    ) : (
                        ''
                    )}
                    {osbDealerStep.selectedDealerProfile.primaryPhone
                        ? parse(callDealerPostfix)
                        : ''}
                </div>
            );
        }
        return null;
    }

    function renderFooterTextMobile() {
        if (isMobileView) {
            return (
                <div className="footer-text">
                    <div
                        dangerouslySetInnerHTML={{
                            __html:
                                dateTimeContent?.[DATE_TIME_STEP.DROP_OFF_TITLE]
                                    ?.toString()
                                    .replace(
                                        '####',
                                        extractTimeString(sameDayPickUp)
                                    ) ?? '',
                        }}
                    />
                    {osbDealerStep.selectedDealerProfile.primaryPhone
                        ? callDealerPrefix
                        : ''}
                    {osbDealerStep.selectedDealerProfile.primaryPhone ? (
                        <a
                            className="call-dealer-link"
                            href={`tel:+${formatMobileNumber(
                                osbDealerStep.selectedDealerProfile.primaryPhone
                            )}`}
                            onClick={triggerCallDealerCtaAnalytics}
                            title={
                                osbDealerStep.selectedDealerProfile.primaryPhone
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {callDealerAnchorText}
                        </a>
                    ) : (
                        ''
                    )}
                    {osbDealerStep.selectedDealerProfile.primaryPhone
                        ? parse(callDealerPostfix)
                        : ''}
                </div>
            );
        }
        return null;
    }

    function renderPickupServiceCalendar() {
        return (
            <div className="osb-pickup-service-calendar-container">
                <LightPickupCalendar
                    dateTimeContent={dateTimeContent}
                    calendarStartDate={calendarStartDate}
                    availableDatesWithTimeslots={availableDatesWithTimeslots}
                    editTrigger={setServiceAppointmentScreen}
                    selectedPickupDateValue={pickupDateChange}
                    selectedPickupTimeslotValue={pickupTimeslotChange}
                />
                <div className="pickup-calendar-continue-button">
                    <FMButton
                        type="primary"
                        label={
                            dateTimeContent?.[
                                DATE_TIME_STEP.CONTINUE_ON_CALENDAR
                            ]?.toString() ?? ''
                        }
                        aria-label={
                            dateTimeContent?.[
                                DATE_TIME_STEP.CONTINUE_ON_CALENDAR
                            ]?.toString() ?? 'Continue'
                        }
                        onClick={goToPersonalDetailsStep}
                        disabled={disablePickupCalendarContinueButton}
                    />
                </div>
            </div>
        );
    }

    function renderBookingSummaryDesktop() {
        if (!isMobileView) {
            return (
                <div className="osb-light-journey-booking-summary">
                    <LightBookingSummary
                        stepName={STEP_PROGRESS_BAR_KEYS.DATETIME}
                        showVoucherLink={true}
                        loadVoucherAlertMessage={loadVoucherAlertMessage}
                    />
                </div>
            );
        }
        return null;
    }

    function renderBookingSummaryMobile() {
        if (isMobileView) {
            return (
                <div className="osb-mobile-booking-summary">
                    <div className="view-summary-accordion">
                        <BookingSummaryAccordion
                            index="0"
                            className=""
                            expandMultiplePanels={true}
                            stepName={STEP_PROGRESS_BAR_KEYS.DATETIME}
                            showVoucherLink={true}
                            loadVoucherAlertMessage={loadVoucherAlertMessage}
                        />
                    </div>
                </div>
            );
        }
        return null;
    }

    return (
        <>
            {httpState.isLoading ? (
                <OsbLoader osbEmptyContentHeight={true} />
            ) : (
                <>
                    <div className="osb-light-journey-datetime-page">
                        {!showPickupServiceCalendar ? (
                            <div className="osb-datetime-container">
                                {errorMsgService.length > 0 ? (
                                    <div className="error-message">
                                        {errorMsgService}
                                    </div>
                                ) : (
                                    ''
                                )}
                                {renderBackButton()}
                                {renderDateTimeTitle()}
                                {renderCalendarComponentPanel()}
                                {renderCalSlotSection()}
                                {renderContinueButton()}
                                {renderFooterTextDesktop()}
                                {renderFooterTextMobile()}
                            </div>
                        ) : (
                            renderPickupServiceCalendar()
                        )}
                        {renderBookingSummaryDesktop()}
                    </div>
                    {renderBookingSummaryMobile()}
                </>
            )}
        </>
    );
};
